module.exports = __webpack_public_path__ + "img/52.983a3275.png";